module.exports = __webpack_public_path__ + "static/media/bindEnterprise2.9052c025.png";